<template>
  <v-col cols="12">
    <gg-card>
      <gg-card-header>
        Shared With Me
      </gg-card-header>
      <gg-card-text>
        <v-data-table :headers="headersMyAccounts"
                      :items="myAccessList"
                      show-expand
                      :expanded.sync="expandedMy"
                      item-key="id"
                      single-expand
                      :loading="!loaded"
        >
          <v-progress-linear slot="progress" color="green" height="2" indeterminate />
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-data-iterator
                :items="item.services"
                hide-default-footer>
                <template v-slot:default="props">
                  <v-row>
                    <v-col v-for="(item, index) in props.items"
                           :key="index"
                           cols="12"
                           sm="6"
                           md="3">
                      <v-card>
                        <v-list dense>
                          <v-list-item>
                            <v-list-item-content>
                              Service ID: <router-link :to="link(item.id)">{{ item.id }}</router-link>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Name: <router-link :to="link(item.id)">{{ item.product }}</router-link>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              Domain: <router-link :to="link(item.id)">{{ item.domain }}</router-link>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              <gg-btn  text @click="openSharedDeleteModal(item)">
                                Delete Access
                                <span class="visually-hidden text-lowercase">button</span>
                              </gg-btn>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </td>
          </template>
        </v-data-table>
      </gg-card-text>
    </gg-card>
    <delete-shared-modal :opened="sharedDeleteModal" :service="sharedServiceToDelete" @close="closeSharedDeleteModal" />
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteSharedModal from 'Components/Profile/Access/Shared/DeleteModal'
import { link } from 'Helpers/profile-access'

export default {
  name: 'SharedServices',
  components: {
    DeleteSharedModal
  },
  data: () => ({
    headersMyAccounts: [
      { text: 'Client ID', value: 'id' },
      { text: 'Client Name', value: 'name' },
      { text: 'Client Email', value: 'email' },
      { text: 'Services', value: 'data-table-expand' },
    ],
    expandedMy: [],
    loaded: false,
    sharedDeleteModal: false,
    sharedServiceToDelete: {}
  }),
  computed: {
    ...mapGetters(['myAccessList', 'services']),
  },
  created () {
    this.loadAccessList()
  },
  methods: {
    ...mapActions(['getAccessList']),
    link,
    async loadAccessList () {
      this.loaded = false
      try {
        await this.getAccessList()
      } catch (e) {
        this.reportError(e)
      }
      this.loaded = true
    },
    openSharedDeleteModal (service) {
      this.sharedDeleteModal = true
      this.sharedServiceToDelete = service
    },
    closeSharedDeleteModal () {
      this.sharedDeleteModal = false
      this.sharedServiceToDelete = {}
    }
  }
}
</script>
